import { render, staticRenderFns } from "./LottieVue.vue?vue&type=template&id=2f984dd0&scoped=true&"
import script from "./LottieVue.vue?vue&type=script&lang=js&"
export * from "./LottieVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f984dd0",
  null
  
)

export default component.exports